import { h } from 'preact';
import * as BaseComp from 'components/bolt/quotesCarousel/quotesCarousel.js';
import Store from 'store/store';
import { sortObjectByOrder } from 'utils/utils';

export default class QuotesCarousel extends BaseComp.default {
	constructor(props) {
		super(props);
		this.activePage = Store.get().activePage;
		// janky bugfix: setting default height to the max height of the image
		this.defaultCarouselHeight = 397;
		this.hideOnDesktop = props.data.hideOnDesktop;
		this.hideOnTablet = props.data.hideOnTablet;
		this.hideOnMobile = props.data.hideOnMobile;
		this.items = sortObjectByOrder(props.data?.items) || [];
		this.state = {
			activeIndex: 0,
			exitingIndex: null,
			headerHeight: 0,
			carouselHeight: this.defaultCarouselHeight
		};
	}
}
